import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import type { FileKnowledge } from '@/graphql/types/chatKnowledge';

interface KnowledgeDetailsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  knowledge: FileKnowledge | null;
}

const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const KnowledgeDetailsDialog = ({
  open,
  onOpenChange,
  knowledge,
}: KnowledgeDetailsDialogProps) => {
  if (!knowledge) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="gap-6 max-w-2xl">
        <DialogHeader className="w-fit">
          <DialogTitle>Detalhes do Conhecimento</DialogTitle>
        </DialogHeader>

        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <Label>Título</Label>
            <div className="p-2 bg-gray-50 rounded-md border text-sm">
              {knowledge.title || '-'}
            </div>
          </div>

          <div className="flex flex-col gap-2">
            <Label>ID</Label>
            <div className="p-2 bg-gray-50 rounded-md border text-sm font-mono">
              {knowledge.id}
            </div>
          </div>

          <div className="flex flex-col gap-2">
            <Label>Categoria</Label>
            <div className="p-2 bg-gray-50 rounded-md border text-sm">
              {knowledge.category || '-'}
            </div>
          </div>

          <div className="flex flex-col gap-2">
            <Label>Tipo</Label>
            <div className="p-2 bg-gray-50 rounded-md border text-sm">
              {knowledge.type || '-'}
            </div>
          </div>

          {knowledge.content && (
            <div className="flex flex-col gap-2">
              <Label>Conteúdo</Label>
              <Textarea
                value={knowledge.content}
                readOnly
                rows={10}
                className="resize-none bg-gray-50"
              />
            </div>
          )}

          <div className="flex flex-col gap-2">
            <Label>Criado em</Label>
            <div className="p-2 bg-gray-50 rounded-md border text-sm">
              {formatDate(knowledge.created_at)}
            </div>
          </div>
        </div>

        <div className="flex justify-end">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Fechar
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
